<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
    >
        <el-form
                :model="dataForm"
                ref="dataForm"
                :rules="dataRule"
                @keyup.enter.native="dataFormSubmit()"
                label-width="132px"
        >
            <el-form-item label="分组名称：" prop="groupName">
                <el-input
                        v-model="dataForm.groupName"
                        placeholder="分组名称"
                ></el-input>
            </el-form-item>
            <el-form-item label="显示表达式：" prop="showExp">
                <el-input
                        placeholder="显示表达式"
                        v-model="dataForm.showExp"
                ></el-input>
            </el-form-item>
            <el-form-item label="数据类型：" prop="datasetType">
                <el-select v-model="dataForm.datasetType" placeholder="数据类型"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in datasetTypeOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排序：" prop="sort">
                <el-input
                        v-model="dataForm.sort"
                        placeholder="排序"
                ></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    const fromData = {
        id: "",
        formId: "",
        groupName: "",
        showExp: "",
        datasetType: 0,
        style: '',
        sort: 10
    }
    export default {
        props: ["mainContentViewHeight"],
        data() {
            return {
                visible: false,
                dataForm: fromData,
                datasetTypeOptions: [{'text': '表单', 'value': 0}, {'text': '列表', 'value': 1}, {'text': '区块', 'value': 2}],
                dataRule: {
                    groupName: [
                        {required: true, message: '数据集编号不能为空', trigger: 'blur'}
                    ],
                }
            };
        },
        methods: {
            init(fromId, id) {
                this.dataForm.id = id || "";
                this.dataForm.formId = fromId || "";
                this.visible = true;
                if (this.dataForm.id) {
                    this.$httpReq({
                        url: this.$httpReq.adornUrl("/customform/fromdatasetgroup/get?id=" + this.dataForm.id),
                        method: "get",
                        baseURL: '',
                    }).then(({data}) => {
                        if (data && data.code === "1") {
                            this.dataForm = data.data;
                        } else {
                            this.dataForm = fromData;
                        }
                    });
                }
            },
            // 表单提交
            dataFormSubmit() {
                if (this.dataForm.formId == undefined) {
                    this.$message.error('自定义表单无效');
                    return;
                }
                this.$httpReq({
                    url: this.$httpReq.adornUrl("/customform/fromdatasetgroup/save"),
                    method: "post",
                    baseURL: '',
                    data: this.dataForm,
                }).then(({data}) => {
                    if (data && data.code === "1") {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                            duration: 1500,
                            onClose: () => {
                                this.visible = false;
                                this.$emit("refreshDataList");
                            },
                        });
                    } else {
                        this.$message.error(data.msg);
                    }
                });
            },
        },
    };
</script>
